__turbopack_context__.v({
  "accountLinks": "public-site-module__1SOrda__accountLinks",
  "brand": "public-site-module__1SOrda__brand",
  "desktopAccount": "public-site-module__1SOrda__desktopAccount",
  "desktopLanguage": "public-site-module__1SOrda__desktopLanguage",
  "desktopNav": "public-site-module__1SOrda__desktopNav",
  "footer": "public-site-module__1SOrda__footer",
  "footerBottom": "public-site-module__1SOrda__footerBottom",
  "footerColumns": "public-site-module__1SOrda__footerColumns",
  "footerCompact": "public-site-module__1SOrda__footerCompact",
  "footerInvitation": "public-site-module__1SOrda__footerInvitation",
  "footerStart": "public-site-module__1SOrda__footerStart",
  "footerStartLink": "public-site-module__1SOrda__footerStartLink",
  "footerStory": "public-site-module__1SOrda__footerStory",
  "footerTop": "public-site-module__1SOrda__footerTop",
  "footerWordmark": "public-site-module__1SOrda__footerWordmark",
  "funnelBar": "public-site-module__1SOrda__funnelBar",
  "funnelCard": "public-site-module__1SOrda__funnelCard",
  "funnelPage": "public-site-module__1SOrda__funnelPage",
  "funnelTools": "public-site-module__1SOrda__funnelTools",
  "header": "public-site-module__1SOrda__header",
  "headerCta": "public-site-module__1SOrda__headerCta",
  "headerInner": "public-site-module__1SOrda__headerInner",
  "headerSource": "public-site-module__1SOrda__headerSource",
  "headerTools": "public-site-module__1SOrda__headerTools",
  "loginLink": "public-site-module__1SOrda__loginLink",
  "menu-enter": "public-site-module__1SOrda__menu-enter",
  "menu-link-enter": "public-site-module__1SOrda__menu-link-enter",
  "menuBrand": "public-site-module__1SOrda__menuBrand",
  "menuClose": "public-site-module__1SOrda__menuClose",
  "menuLanguage": "public-site-module__1SOrda__menuLanguage",
  "menuToggle": "public-site-module__1SOrda__menuToggle",
  "menuTools": "public-site-module__1SOrda__menuTools",
  "menuTop": "public-site-module__1SOrda__menuTop",
  "mobileAccount": "public-site-module__1SOrda__mobileAccount",
  "mobileAccountTop": "public-site-module__1SOrda__mobileAccountTop",
  "mobileExtras": "public-site-module__1SOrda__mobileExtras",
  "mobileLanguage": "public-site-module__1SOrda__mobileLanguage",
  "mobileLogin": "public-site-module__1SOrda__mobileLogin",
  "mobileMenu": "public-site-module__1SOrda__mobileMenu",
  "mobileNav": "public-site-module__1SOrda__mobileNav",
  "noScriptNav": "public-site-module__1SOrda__noScriptNav",
  "reading-progress": "public-site-module__1SOrda__reading-progress",
  "readingBar": "public-site-module__1SOrda__readingBar",
  "site": "public-site-module__1SOrda__site",
  "themeControl": "public-site-module__1SOrda__themeControl",
});
